import { Action, createReducer, on } from '@ngrx/store';

import { Logout, ModelState } from '@personal-area/global/state';

import { Promo } from '../../models/promo';
import {
  GetPromos,
  GetPromosFail,
  GetPromosSuccess,
  GetStats,
  GetStatsFail,
  GetStatsSuccess,
  SelectPromo,
  UpdateStats,
} from '../actions/promo';

export interface PromoState extends ModelState {
  list: Promo[];
  selectedPromoName: string;
  stats: { [promoName: string]: any };
  isLoadingFailed: boolean;
  areStatsLoading: boolean;
}

export const initialState: PromoState = {
  list: [],
  selectedPromoName: null,
  stats: null,
  isLoaded: false,
  isLoading: false,
  isLoadingFailed: false,
  areStatsLoading: false,
};

const _reducer = createReducer(
  initialState,
  on(GetPromos, state => {
    return {
      ...state,
      isLoading: true,
      isLoadingFailed: false
    };
  }),
  on(GetPromosSuccess, (state, { promos }) => {
    return {
      ...state,
      list: [...promos].sort((a, b) => b.sort_weight - a.sort_weight),
      isLoading: false,
      isLoaded: true,
      isLoadingFailed: false
    };
  }),
  on(GetPromosFail, state => {
    return {
      ...state,
      isLoading: false,
      isLoadingFailed: true
    };
  }),
  on(SelectPromo, (state, { name }) => {
    return {
      ...state,
      selectedPromoName: name,
    };
  }),
  on(GetStats, state => {
    return {
      ...state,
      areStatsLoading: true
    };
  }),
  on(GetStatsFail, state => {
    return {
      ...state,
      areStatsLoading: false
    };
  }),
  on(GetStatsSuccess, (state, { stats }) => {
    const updatedStats = Object.assign({}, state.stats);
    const bonusStats = Object.assign({}, stats);

    bonusStats.daysLeft = bonusStats.name === 'vps'
      ? Math.ceil((+new Date(bonusStats.expiredAt) - Date.now()) / (1000 * 3600 * 24))
      : bonusStats.daysLeft;
    bonusStats.isBonusRequirementsFulfilled = false;

    if (updatedStats[bonusStats.name]) {
      bonusStats.minLots = updatedStats[bonusStats.name].minLots;
    }

    updatedStats[bonusStats.name] = bonusStats;

    return {
      ...state,
      stats: updatedStats,
      areStatsLoading: false
    };
  }),
  on(UpdateStats, (state, { stats }) => {
    const updatedStats = Object.assign({}, state.stats);
    const bonusStats = Object.assign({}, updatedStats[stats.name]);

    bonusStats.minLots = stats.lotsRequired;

    updatedStats[bonusStats.name] = bonusStats;

    return {
      ...state,
      stats: updatedStats
    };
  }),
  on(Logout, state => initialState),
);

export const promoReducer = (state: PromoState | undefined, action: Action) => _reducer(state, action);
